import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["children", "color", "intent", "contrast"];
var _templateObject;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
import React from 'react';
import { getIconColor, getIconIntent, ICON_COLORS, ICON_COLORS_SHADES } from "../utils";
var SIZE_PX = 48;
var StyledSvgIcon = styled('svg', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'contrast', 'intent', 'shade'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", ";\n  flex-shrink: 0;\n  height: ", "px;\n  width: ", "px;\n"])), function (_ref) {
  var color = _ref.color,
    intent = _ref.intent,
    shade = _ref.shade,
    _ref$contrast = _ref.contrast,
    contrast = _ref$contrast === void 0 ? 'mid' : _ref$contrast;
  if (intent || contrast === 'inverted') {
    return getIconIntent(intent, contrast);
  } else if (color || shade) {
    if (!ICON_COLORS.includes(color) || !ICON_COLORS_SHADES.includes(shade)) {
      return 'black';
    }
    return getIconColor(color, shade);
  }
  return 'black';
}, SIZE_PX, SIZE_PX);
export var SvgHifiIcon = function SvgHifiIcon(_ref2) {
  var children = _ref2.children,
    _color = _ref2.color,
    intent = _ref2.intent,
    _ref2$contrast = _ref2.contrast,
    contrast = _ref2$contrast === void 0 ? 'regular' : _ref2$contrast,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var colorSplit = (_color !== null && _color !== void 0 ? _color : '').split('.');
  // @ts-expect-error: `height` prop isn't for this component but we're checking it here to throw an error.
  if (otherProps.height) {
    throw new Error('This is a high-fidelity icon and does not support the "height" prop as these icons are a ' + 'fixed size.');
  }
  // @ts-expect-error: `width` prop isn't for this component but we're checking it here to throw an error.
  if (otherProps.width) {
    throw new Error('This is a high-fidelity icon and does not support the "width" prop as these icons are a ' + 'fixed size.');
  }
  // @ts-expect-error: `size` prop isn't for this component but we're checking it here to throw an error.
  if (otherProps.size) {
    throw new Error('This is a high-fidelity icon and does not support the "size" prop as these icons are a ' + 'fixed size.');
  }
  return /*#__PURE__*/React.createElement(StyledSvgIcon, {
    "aria-hidden": otherProps['aria-label'] ? undefined : true,
    "aria-label": otherProps['aria-label'],
    color: _color ? colorSplit[0] : undefined,
    intent: intent,
    contrast: contrast,
    role: "img",
    shade: _color ? colorSplit[1] : undefined,
    viewBox: "0 0 ".concat(SIZE_PX, " ").concat(SIZE_PX),
    xmlns: "http://www.w3.org/2000/svg"
  }, children);
};